var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable, Injector } from "@angular/core";
import { MathUtils } from "../utility/math-utils";
import { OrderManager } from "./order-manager";
import { MenuManager } from "./menu-manager";
/**
 * This discount manager is used to
 * calculate all discounts applied for current order
 * @function applyPromotion: apply all discounts orderly by priority,
 *           and calculate the order grand total
 * @function apply: apply one discount, check if all conditions are satisfied
 *           and then apply discount via main condition
 * **/
var DiscountManager = /** @class */ (function () {
    function DiscountManager(injector) {
        this.orderManager = injector.get(OrderManager);
        this.menuManager = injector.get(MenuManager);
    }
    /**apply discount, by priority (sorted on server)
     *can apply multiple discounts
     * **/
    DiscountManager.prototype.applyPromotions = function (order, promotions, multiordermanager) {
        order.discount = 0;
        order.discounts = [];
        var applied = 0;
        for (var _i = 0, promotions_1 = promotions; _i < promotions_1.length; _i++) {
            var promo = promotions_1[_i];
            if (applied && promo.alone)
                continue;
            var success = this.apply(order, promo, null, null, multiordermanager);
            if (success && promo.benefits[0] && promo.benefits[0].isDiscount()) {
                applied++;
                console.log("applied ", promo.name);
            }
        }
        // in case calculate new tax
        this.orderManager.calcDiscountGrandTotal(order);
    };
    DiscountManager.prototype.sortDiscountPrioInDescending = function (promos) {
        promos = promos.sort(function (a, b) { return (b.priority - a.priority); });
        return promos;
    };
    DiscountManager.prototype.checkGroupPriority = function (order, promo) {
        var canApply = true;
        if (order.discounts.length > 0) { // filter group & 
            var discountGroupMap_1 = {};
            order.discounts.map(function (d) {
                if (d.group) {
                    discountGroupMap_1[d.group] = discountGroupMap_1[d.group] ? discountGroupMap_1[d.group].push([d]) : discountGroupMap_1[d.group] = [d];
                }
            });
            if (discountGroupMap_1[promo.group]) {
                var sameGroupDiscounts = discountGroupMap_1[promo.group];
                sameGroupDiscounts.map(function (gd) {
                    if (gd.priority > promo.priority)
                        canApply = false;
                });
            }
        }
        return canApply;
    };
    DiscountManager.prototype.checkGroupPrioritywithOrders = function (orders, promo) {
        var canApply = true;
        orders.forEach(function (order) {
            if (order.discounts.length > 0) { // filter group & 
                var discountGroupMap_2 = {};
                order.discounts.map(function (d) {
                    if (d.group) {
                        discountGroupMap_2[d.group] = discountGroupMap_2[d.group] ? discountGroupMap_2[d.group].push([d]) : discountGroupMap_2[d.group] = [d];
                    }
                });
                if (discountGroupMap_2[promo.group]) {
                    var sameGroupDiscounts = discountGroupMap_2[promo.group];
                    sameGroupDiscounts.map(function (gd) {
                        if (gd.priority > promo.priority)
                            canApply = false;
                    });
                }
            }
        });
        return canApply;
    };
    DiscountManager.prototype.applyOrderPromotions = function (order, promotions, orderManager, isStaff, multiorderManager, calSafe) {
        if (isStaff === void 0) { isStaff = false; }
        // if isStaff = true, can use item level discount/
        var sortPromotions = this.sortDiscountPrioInDescending(promotions);
        order.discount = 0;
        order.discounts = [];
        order.grandTotal = order.total;
        var applied = 0;
        for (var _i = 0, sortPromotions_1 = sortPromotions; _i < sortPromotions_1.length; _i++) {
            var promo = sortPromotions_1[_i];
            if (applied && promo.alone)
                continue;
            var success = this.apply(order, promo, orderManager, isStaff, multiorderManager);
            if (success && promo.benefits[0] && promo.benefits[0].isDiscount()) {
                applied++;
                console.log("applied ", promo.name);
            }
        }
        if (calSafe) {
            this.orderManager.calcOrderSafe(order, multiorderManager.storesMap[order.storeId]);
            return;
        }
        // in case calculate new tax
        orderManager ? orderManager.calcDiscountGrandTotal(order) : this.orderManager.calcDiscountGrandTotal(order);
    };
    DiscountManager.prototype.checkItemDiscountCanApply = function (item, promo, store, isStaff) {
        var conditions = promo.conditions;
        var benefits = promo.benefits;
        promo.available = 0;
        var now = this.menuManager.getTime(store);
        if (!this.menuManager.isAvailabeByPeriods(store, promo.periods, now)) {
            return false;
        }
        if (!conditions || conditions.length === 0 || !benefits || benefits.length === 0 || !promo.enabled)
            return false;
        var ok = true;
        conditions.forEach(function (c) {
            if (ok && !c.isItemSatisfied(item, promo, c, store, isStaff))
                ok = false;
        });
        return ok;
    };
    DiscountManager.prototype.getItemdiscountedPrice = function (item, discounts, store, isStaff, source) {
        var price = item.price;
        var sortPromotions = this.sortDiscountPrioInDescending(discounts);
        for (var _i = 0, sortPromotions_2 = sortPromotions; _i < sortPromotions_2.length; _i++) {
            var promo = sortPromotions_2[_i];
            if (promo.alone)
                continue;
            if (promo.disabledChannels && source) {
                if (promo.disabledChannels.indexOf(source) !== -1)
                    continue;
            }
            if (this.checkItemDiscountCanApply(item, promo, store, isStaff)) {
                price = this.applyItem(item, promo);
                break;
            }
        }
        return price;
    };
    DiscountManager.prototype.applyItem = function (item, discount) {
        var discountedItemPrice = item.price;
        var benefit = discount.benefits[0];
        var condition = this.getMainCondition(discount.conditions);
        var amount = benefit.amount, type = benefit.type, used = benefit.used, percent = benefit.percent;
        switch (type) {
            case 'amount': {
                if (amount > 0) {
                    discountedItemPrice = item.price - MathUtils.round(amount, 1);
                }
                break;
            }
            case 'percent': {
                discountedItemPrice = item.price - MathUtils.floor(item.price * percent / 100.00, 1);
                break;
            }
            default:
                break;
        }
        return discountedItemPrice;
    };
    /**
   * Apply one single discount
   * check all conditions
   * take main condition to apply discount
   * **/
    DiscountManager.prototype.checkPromotionConditionCanApply = function (order, promo) {
        var conditions = promo.conditions;
        var benefits = promo.benefits;
        promo.available = 0;
        var now = this.menuManager.getTime(this.orderManager.store);
        if (promo && promo.periods && promo.periods.length > 0) {
            if (!this.menuManager.isAvailabeByPeriods(this.orderManager.store, promo.periods, now))
                return false;
        }
        if (!conditions || conditions.length === 0 || !benefits || benefits.length === 0 || !promo.enabled)
            return false;
        var ok = true;
        conditions.forEach(function (c) {
            if (ok && !c.isSatisfied(order, promo))
                ok = false;
        });
        return ok;
    };
    /**
     * Apply one single discount
     * check all conditions
     * take main condition to apply discount
     * **/
    DiscountManager.prototype.apply = function (order, promo, orderManager, isStaff, multiorderManager) {
        var conditions = promo.conditions;
        var benefits = promo.benefits;
        promo.available = 0;
        // order.orderitems.forEach(oi=>{oi.discounts = [];});
        console.log("applying discount...");
        console.log("conditions:", conditions);
        console.log("benefits:", benefits);
        console.log("order", order);
        console.log("discount", promo);
        var now = this.menuManager.getTime(orderManager ? orderManager : this.orderManager.store);
        if (promo && promo.periods && promo.periods.length > 0) {
            return this.menuManager.isAvailabeByPeriods(orderManager ? orderManager.store : this.orderManager.store, promo.periods, now);
        }
        if (!this.checkGroupPrioritywithOrders(multiorderManager.getOrders(), promo))
            return false;
        if (!conditions || conditions.length === 0 || !benefits || benefits.length === 0 || !promo.enabled)
            return false;
        var ok = true;
        // let canUseAllLevelDiscount = !isCourtDiscount
        // if (isStaff) {
        //     // condition is memberType & isStaff=true. can use all Level discount
        //     promo.conditions.map((c) => {
        //         if (c.type === 'membertype') {
        //             canUseAllLevelDiscount = true
        //         }
        //     })
        // }     
        conditions.forEach(function (c) {
            if (ok && !c.isSatisfied(order, promo, c, isStaff, multiorderManager))
                ok = false;
        });
        if (ok) { // all conditions are satisfied
            var c = this.getMainCondition(conditions);
            var b = promo.benefits[0];
            var amount = c.apply(order, promo, b, multiorderManager);
            console.log("condition ok ", c.display);
            console.log("applying discount amount: ", amount);
            promo.level = c.level;
            if (amount > 0) { //calculable discount
                amount = MathUtils.round(amount, 2);
                promo.amount = amount;
                promo.quantity = 1;
                // let needPushInOrder = true
                // promo.conditions.forEach(c => {
                //     if (c.type === 'itemgroup' || c.type === 'item' || c.type === 'itemgroup_count') {
                //         needPushInOrder = false;
                //     } 
                // });
                // needPushInOrder && 
                var promo_ = JSON.parse(JSON.stringify(promo));
                order.discounts.push(promo_);
                if (multiorderManager) {
                    if (!multiorderManager.orderDisountMap[order.storeId]) {
                        multiorderManager.orderDisountMap[order.storeId] = {};
                        multiorderManager.orderDisountMap[order.storeId][promo.name] = amount;
                    }
                    else {
                        multiorderManager.orderDisountMap[order.storeId][promo.name] = amount;
                    }
                }
                var totalDeduct = amount;
                console.log("Total deduct: ", totalDeduct);
                var grandTotal = order.grandTotal - totalDeduct;
                var discount = order.discount + totalDeduct;
                order.grandTotal = grandTotal;
                order.discount = discount;
            }
            else if (b.applied) { //unlock a new discount, or gift discount (not calculable)
            }
            else {
                console.log("skipping-", promo.name, ": conditions satisfied, benefit not applicable");
                ok = false; //if apply at least one discount
            }
        }
        else {
            promo.available = 0;
        }
        return ok;
    };
    /**
     * Get main condition for a discount
     * when there is a condition is of item level, the first item level condition is the main condition,
     * otherwise, the first condition is the main condition
     * **/
    DiscountManager.prototype.getMainCondition = function (conds) {
        var mainCond;
        conds.forEach(function (c) {
            if (!mainCond)
                if (c.level == "item")
                    mainCond = c;
        });
        if (!mainCond)
            mainCond = conds[0];
        return mainCond;
    };
    DiscountManager = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Injector])
    ], DiscountManager);
    return DiscountManager;
}());
export { DiscountManager };
//# sourceMappingURL=discount-manager.js.map